import { applyDiscount } from './apply-discount/applyDiscount.ts'
import { updateServiceContract } from './updateServiceContract.ts'

export default {
  applyDiscount,
  updateServiceContract
}
